import React from 'react'
import PropTypes from 'prop-types'

export const HeaderContext = React.createContext()

export class HeaderProvider extends React.Component {
  static contextType = HeaderContext

  static propTypes = {
    header: PropTypes.shape({
      html: PropTypes.string,
      bundle: PropTypes.string,
      styles: PropTypes.string
    })
  }

  render() {
    const { header, children } = this.props
    return <HeaderContext.Provider value={header}>{children}</HeaderContext.Provider>
  }
}
